import React from "react";
import { I18n } from "@aws-amplify/core";
import { get, size, flatten, map, sortBy, filter, includes } from "lodash";

import Grid from "@material-ui/core/Grid";

import CustomInput from "../../Common/CustomInput";
import CustomSelect from "../../Common/CustomSelect";
import CustomButton from "../../Common/CustomButton";
import Loader from "../../Common/Loader";
import NoteNew from "./NoteNew";

import { fetchPost } from "../../../api/fetch";

import { isUnknownProfile } from "../../../utils/profile";
import { getUser } from "../../../utils/users";

import images from "../../../assets/img/images";

const LogDetailsNotesNew = (props) => {
  const { log, refreshLog, permissions } = props;

  const [notes, setNotes] = React.useState();
  const [isFetching, setIsFetching] = React.useState(false);
  const [editMode, setEditMode] = React.useState(false);
  const [newNoteDesc, setNewNoteDesc] = React.useState();
  const [newNoteAbout, setNewNoteAbout] = React.useState();

  React.useEffect(() => {
    fetchNotes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [get(log, ["id"])]);

  const fetchNotes = async () => {
    try {
      setIsFetching(true);
      let res = await fetchPost("new/event_groups", {
        filter: {
          parent_ids: [get(log, ["id"])],
        },
        data: ["id", "type", "profile", "notes"],
      });
      let notes = [
        ...res.items,
        {
          id: get(log, ["id"]),
          type: get(log, ["type"]),
          notes: get(log, ["notes"]),
        },
      ];
      notes = await fetchCreatedByUsers(notes);
      setNotes(notes);
    } catch (e) {
      console.log(e);
    }
    setIsFetching(false);
  };

  const fetchCreatedByUsers = async (events) => {
    for (let i = 0; i < size(events); i++) {
      let e = get(events, [i]);
      if (e.updated_by && !isNaN(parseInt(e.updated_by))) {
        let usr = await getUser(e.updated_by);
        e.updated_by = `${get(usr, ["profile", "firstname"])} ${get(usr, [
          "profile",
          "lastname",
        ])}`;
      }
      if (size(get(e, ["notes"])) > 0) {
        e.notes = await fetchCreatedByUsers(get(e, ["notes"]));
      }
    }
    return events;
  };

  const saveNote = async () => {
    setEditMode(false);
    try {
      let id = get(
        filter(notes, (n) => get(n, ["type", "id"]) === newNoteAbout),
        [0, "id"]
      );
      let profileId = get(
        filter(notes, (n) => get(n, ["type", "id"]) === newNoteAbout),
        [0, "profile", "id"]
      );
      let note = {
        description: newNoteDesc,
      };

      if (profileId && !isUnknownProfile(profileId)) {
        note.profile_id = profileId;
      }
      await fetchPost(`event_groups/${id}/notes`, note);
      await refreshLog();
      fetchNotes();
    } catch (e) {
      console.log(e);
    }
    setNewNoteDesc();
    setNewNoteAbout();
  };

  if (get(permissions, ["notes", "read"]) === false) {
    return null;
  }

  if (isFetching) {
    return (
      <Grid
        container
        alignItems="center"
        justify="center"
        style={{ height: "-webkit-fill-available" }}
      >
        <Grid item>
          <Loader message={I18n.get("common_loading")} noDecoration />
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid
      container
      direction="column"
      style={{
        width: "650px",
        padding: "21px",
        paddingTop: "0px",
      }}
    >
      <Grid item>
        <CustomButton
          variant="contained"
          color="primary"
          disabled={editMode || get(permissions, ["notes", "create"]) === false}
          startIcon={
            <img
              src={
                editMode || get(permissions, ["notes", "create"]) === false
                  ? images.plusIconDarkGrey
                  : images.plusIconWhite
              }
              alt="plus"
            />
          }
          onClick={() => setEditMode(true)}
          style={{ marginBottom: "20px" }}
        >
          {I18n.get("common_new")}
        </CustomButton>
      </Grid>
      {editMode && (
        <>
          <Grid item style={{ marginBottom: "10px" }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item className="text-54">
                {I18n.get("site_noteAbout")}
              </Grid>
              <Grid item style={{ width: "200px" }}>
                <CustomSelect
                  name="noteAbout"
                  value={newNoteAbout || ""}
                  onChange={(e) => setNewNoteAbout(e.target.value)}
                  options={map(
                    filter(notes, (n) =>
                      includes([1, 2, 3, 4, 5, 10, 11], get(n, ["type", "id"]))
                    ),
                    (n) => ({
                      id: get(n, ["type", "id"]),
                      name: includes([2, 3, 4, 5], get(n, ["type", "id"]))
                        ? I18n.get("site_summary")
                        : includes([1], get(n, ["type", "id"]))
                        ? I18n.get("site_human")
                        : includes([10], get(n, ["type", "id"]))
                        ? I18n.get("site_truck")
                        : includes([11], get(n, ["type", "id"]))
                        ? I18n.get("site_trailer")
                        : "",
                    })
                  )}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <CustomInput
              name="description"
              value={newNoteDesc || ""}
              onChange={(e) => setNewNoteDesc(e.target.value)}
              multiline={true}
              rows={5}
            />
          </Grid>
          <Grid item style={{ textAlign: "right" }}>
            <CustomButton
              color="primary"
              style={{ margin: "10px 10px 0px 0px" }}
              onClick={() => setEditMode(false)}
            >
              {I18n.get("site_cancel")}
            </CustomButton>
            <CustomButton
              variant="contained"
              color="primary"
              style={{ margin: "10px 0px 0px 0px" }}
              disabled={newNoteDesc ? false : true}
              onClick={saveNote}
            >
              {I18n.get("site_save")}
            </CustomButton>
          </Grid>
        </>
      )}
      {map(
        sortBy(
          flatten(
            map(notes, (n) =>
              map(get(n, ["notes"]), (note) => ({
                ...note,
                type: get(n, ["type"]),
              }))
            )
          ),
          (n) => -get(n, ["updated_on"])
        ),
        (note) => (
          <Grid item key={note.id}>
            <hr
              style={{
                borderLeft: "none",
                margin: "25px",
                color: "black",
                opacity: "0.3",
              }}
            />
            <NoteNew note={note} />
          </Grid>
        )
      )}
    </Grid>
  );
};

export default LogDetailsNotesNew;
